export const PIPELINE_CATEGORIES = {
  NONE: 0,
  LEAD: 1,
  APPLICATION: 2,
  OPPORTUNITY: 3,
};
